export default "__VITE_ASSET__BfL$3xdW__"